import { RootState } from '@dis/redux'

export const selectIsBrowserOnline = (state: RootState) => state.api.isBrowserOnline

export const selectIsWebsocketConnected = (state: RootState) => state.api.isWebsocketConnected

export const selectWebsocketConnectionId = (state: RootState) => state.api.websocketConnectionId
